module.exports = __webpack_public_path__ + "img/chaos_section_bg.7415a4fa.png";